import { authConfig } from '../config/auth';
import { tokenManager, AuthTokens } from './auth';

/**
 * Refresh authentication tokens using the refresh token.
 * Called by AuthContext on startup and in the background refresh interval.
 */
export const refreshAuthTokens = async (): Promise<AuthTokens | null> => {
  try {
    const refreshToken = tokenManager.getRefreshToken();
    if (!refreshToken) {
      return null;
    }

    const response = await fetch(`${authConfig.apiUrl}/api/auth/refresh`, {
      method: 'POST',
      headers: {
        'Content-Type': 'application/json',
      },
      body: JSON.stringify({ refreshToken }),
    });

    if (!response.ok) {
      if (response.status === 400 || response.status === 401) {
        // Cognito explicitly rejected the refresh token — wipe it so we don't retry forever
        tokenManager.clearTokens();
      }
      // 5xx or network errors are transient — don't clear, let the caller retry
      return null;
    }

    const data = await response.json();

    if (data.authenticationResult) {
      const newTokens: AuthTokens = {
        accessToken: data.authenticationResult.AccessToken,
        idToken: data.authenticationResult.IdToken,
        refreshToken: refreshToken, // Cognito doesn't rotate refresh tokens
        expiresIn: data.authenticationResult.ExpiresIn,
        expiresAt: Date.now() + (data.authenticationResult.ExpiresIn * 1000),
      };

      tokenManager.saveTokens(newTokens);
      return newTokens;
    }

    return null;
  } catch (error) {
    console.error('Token refresh error:', error);
    return null;
  }
};
